/**
 * Строка о сбое плеера для помощника зрителя (кнопка PLAYBACK_ERROR): тип и
 * детали ошибки hls.js, HTTP-код, код MediaError. Помощник по ней отличает
 * «манифест 404» от «плохой сети», бэкенд кладёт её в контекст хода и в
 * details черновика обращения. Адреса вырезаются: в них подписанные токены.
 */

/** Нужные поля hls.js ErrorData, без импорта hls.js в чистый модуль. */
export interface HlsErrorLike {
  type: string;
  details: string;
  fatal: boolean;
  response?: { code?: number } | null;
  networkDetails?: unknown;
  reason?: string;
  error?: { message?: string } | null;
}

const MESSAGE_MAX_LENGTH = 120;

const MEDIA_ERROR_NAMES: Record<number, string> = {
  1: "MEDIA_ERR_ABORTED",
  2: "MEDIA_ERR_NETWORK",
  3: "MEDIA_ERR_DECODE",
  4: "MEDIA_ERR_SRC_NOT_SUPPORTED",
};

function cleanMessage(message: string | undefined | null): string | null {
  const text = message
    ?.replace(/(https?|blob):\/\/\S+/g, "<url>")
    .replace(/\s+/g, " ")
    .trim();
  return text ? text.slice(0, MESSAGE_MAX_LENGTH) : null;
}

function httpCode(data: HlsErrorLike): number | null {
  const code = data.response?.code;
  if (typeof code === "number" && code > 0) return code;
  const status = (data.networkDetails as { status?: unknown } | null)?.status;
  return typeof status === "number" && status > 0 ? status : null;
}

export function describeHlsError(data: HlsErrorLike): string {
  const parts = [`hls ${data.type} ${data.details}`];
  if (data.fatal) parts.push("fatal");
  const code = httpCode(data);
  if (code) parts.push(`HTTP ${code}`);
  const message = cleanMessage(data.reason ?? data.error?.message);
  return message ? `${parts.join(" ")}: ${message}` : parts.join(" ");
}

export function describeMediaError(
  error: { code: number; message?: string } | null | undefined,
): string {
  if (!error) return "video error";
  const name = MEDIA_ERROR_NAMES[error.code] ?? `code ${error.code}`;
  const message = cleanMessage(error.message);
  return message ? `video ${name}: ${message}` : `video ${name}`;
}
